import { FC } from 'react';
import { NudosButton, NudosGenericModal, NudosModalContent } from '../../../../../components/NudosComponents';
import { IStockOrderData, IStockOrderDetail, SHIPMENT_STATUS_STOCK_ORDER } from '../../../../../types/stockOrders';
import {
  displayErrorNotification,
  displaySuccessNotification
} from '../../../../../utils/displayNudosStandardNotifications';
import { cancelStockOrder } from '../../../../../services/stockOrders';
import { useParams } from 'react-router-dom';
import StockOrderCard from '../../../../stockOrdersModule/components/StockOrderCard/StockOrderCard';
import './CancelStockOrderModal.scss';

interface ICancelStockOrderModal {
  closeModal?: () => void;
  stockOrderData: IStockOrderDetail;
  onSuccess?: () => void;
  loading?: boolean;
  setIsLoading: (loading: boolean) => void;
}

const CancelStockOrderModal: FC<ICancelStockOrderModal> = ({
  closeModal,
  stockOrderData,
  onSuccess,
  loading,
  setIsLoading
}: ICancelStockOrderModal) => {
  const { uuid } = useParams<{ uuid: string }>();

  const transformStockOrderData = {
    orderId: stockOrderData.orderId,
    uuid,
    country: {
      name: stockOrderData.country.name,
      code: stockOrderData.country.code,
      flag: stockOrderData.country.flag
    },
    createdAt: stockOrderData.generalData.shipments[0]?.statusLog[0]?.createdAt || new Date().toISOString(),
    providerName: stockOrderData.generalData.providerInfo.name,
    nextDeliveryDate: null,
    deliveryDate: null,
    canceledAt: null,
    totalValue: stockOrderData.billingData.total,
    currency: stockOrderData.billingData.orderResume[0].currency,
    shipments: {
      confirmed: stockOrderData.generalData.shipments.filter(s => s.status === 'Confirmada').length,
      deliveryProcess: stockOrderData.generalData.shipments.filter(s => s.status === 'Proceso de entrega').length,
      delayed: stockOrderData.generalData.shipments.filter(s => s.status === 'Atrasada').length,
      delivered: stockOrderData.generalData.shipments.filter(s => s.status === 'Entregada').length
    },
    units: stockOrderData.generalData.shipments.reduce((acc, curr) => acc + Number(curr.quantity), 0),
    stockOrderComments: stockOrderData.stockOrderComments,
    status: undefined
  };

  const handleCancelOrder = async () => {
    try {
      setIsLoading(true);
      await cancelStockOrder(uuid);
      displaySuccessNotification({
        customJSXMessage: <>Orden cancelada exitosamente</>
      });
      if (onSuccess) {
        onSuccess();
      }
      if (closeModal) {
        closeModal();
      }
    } catch (error) {
      displayErrorNotification({
        customJSXMessage: <>Error al cancelar la orden</>
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <NudosGenericModal
      closeModalCallback={closeModal}
      clickOutsideCallback={closeModal}
      modalContent={
        <NudosModalContent
          noScroll
          customWidth="580px"
          customHeight="426px"
          modalContentTitle="Cancelar orden de stock"
          toCloseModal={closeModal}
          CustomModalComponent={
            <div id="cancelStockOrderModal">
              <div className="containerCancelModal">
                <div className="titleCancel">Estás a punto de cancelar la siguiente orden:</div>
                <div className="centerCardCancel">
                  <StockOrderCard
                    data={transformStockOrderData as IStockOrderData}
                    shipmentStatusName={SHIPMENT_STATUS_STOCK_ORDER.CANCELLED}
                  />
                </div>
                <div className="questionText">¿Seguro que deseas continuar?</div>
                <div className="containerButtons">
                  <NudosButton
                    handleClick={closeModal}
                    colorPalette="secondary"
                    customClassName="firstButton"
                    buttonText="Mantener"
                    isButtonDisabled={loading}
                  />
                  <NudosButton
                    isButtonDisabled={loading}
                    isButtonLoading={loading}
                    handleClick={handleCancelOrder}
                    customClassName="secondButton"
                    buttonText="Cancelar Orden"
                  />
                </div>
              </div>
            </div>
          }
        />
      }
    />
  );
};

export default CancelStockOrderModal;
